<template>
  <div>
    <CreateVersion />
  </div>
</template>

<script>
import CreateVersion from '../../components/ride-hailing/versions/index.vue'

export default {
  components: {
    CreateVersion,
  },
}
</script>
